import { useEffect, useRef } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { useHistory } from 'react-router-dom';
import {
  clearPendingDeepLink,
  loadPendingDeepLink,
} from '../lib/deepLinks';

/**
 * After sign-in/sign-up, open a pending /c or /t share destination once.
 */
export function DeepLinkRunner() {
  const { isSignedIn, isLoaded } = useAuth();
  const history = useHistory();
  const ranRef = useRef(false);

  useEffect(() => {
    if (!isLoaded || !isSignedIn || ranRef.current) return;
    const path = loadPendingDeepLink();
    if (!path) return;
    ranRef.current = true;
    clearPendingDeepLink();
    history.replace(path);
  }, [isLoaded, isSignedIn, history]);

  return null;
}

export default DeepLinkRunner;
